import { createSlice } from "@reduxjs/toolkit";
import { 
    addMetaData,
    updateMetaData,
    getMetaData
} from "./ThunkActions";
import { iMetaDataState, REDUCER_NAME } from "./Type";

const initialState: iMetaDataState = {
    isLoading: false,
    metaDataList: [],
    errorMessage: null,
};

export const metaDataSlice = createSlice({
    name: REDUCER_NAME,
    initialState,
    reducers: {
        resetMetaDataState: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            /* ---------------- ADD META DATA ---------------- */
            .addCase(addMetaData.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = null;
            })
            .addCase(addMetaData.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload?.data?.data?.metaTags) {
                    state.metaDataList = payload.data.data.metaTags;
                }
                state.isLoading = false;
            })
            .addCase(addMetaData.rejected, (state, action) => {
                // @ts-expect-error
                state.errorMessage = action.payload?.message ?? "Failed to add metadata";
                state.isLoading = false;
            })

            /* ---------------- UPDATE META DATA ---------------- */
            .addCase(updateMetaData.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = null;
            })
            .addCase(updateMetaData.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload?.data?.data) {
                    // Update the specific meta tag in the list
                    const updatedMetaId = action.meta.arg.metaId;
                    const updatedData = action.meta.arg.data;
                    
                    state.metaDataList = state.metaDataList.map((meta) =>
                        meta.id === updatedMetaId
                            ? { ...meta, ...updatedData }
                            : meta
                    );
                }
                state.isLoading = false;
            })
            .addCase(updateMetaData.rejected, (state, action) => {
                // @ts-expect-error
                state.errorMessage = action.payload?.message ?? "Failed to update metadata";
                state.isLoading = false;
            })

            /* ---------------- GET META DATA ---------------- */
            .addCase(getMetaData.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = null;
            })
            .addCase(getMetaData.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload?.data?.data?.metaTags) {
                    state.metaDataList = payload.data.data.metaTags;
                }
                state.isLoading = false;
            })
            .addCase(getMetaData.rejected, (state, action) => {
                // @ts-expect-error
                state.errorMessage = action.payload?.message ?? "Failed to fetch metadata";
                state.isLoading = false;
            });
    }
});

export const { resetMetaDataState } = metaDataSlice.actions;
export default metaDataSlice.reducer;